import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { DelinquentClaimsSummaryReportParams } from '../DelinquentClaimsReport.types';

export const QUERY_KEY = 'EXPORT_DELINQUENT_CLAIMS_SUMMARY_CSV';

const useDelinquentClaimsReportExportSummaryCSVQuery = (params: DelinquentClaimsSummaryReportParams) => {
  const handleSaveFile = useDownloadCSV();
  const getEmployerIdParam = useGetEmployerIdParam({
    isMultipleEmployerMode: params.isMultipleEmployer,
  });
  const [isLoading, setIsLoading] = useState(false);

  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(
        params.isMultipleEmployer
          ? API_URL.REPORTS_DELINQUENT_CLAIMS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV
          : API_URL.REPORTS_DELINQUENT_CLAIMS_REPORT_SUMMARY_EXPORT_CSV,
        {
          params: _.pickBy({
            ...getEmployerIdParam(params.employerId, params.employerIds),
            account_types:
              params.accountTypes && !params.accountTypes.includes(ALL_OPTION_KEY)
                ? params.accountTypes.join(',')
                : undefined,
            plan_ids:
              !params.isMultipleEmployer && params.planIds && !params.planIds.includes(ALL_OPTION_KEY)
                ? params.planIds.join(',')
                : undefined,
            plan_year_period:
              params.planYearPeriod && !params.planYearPeriod.includes(ALL_OPTION_KEY)
                ? params.planYearPeriod.join(',')
                : undefined,
          }),
        }
      ),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response.data?.data, 'csv', 'delinquent_claims_summary');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);

  return {
    isLoading,
    handleExport,
  };
};

export default useDelinquentClaimsReportExportSummaryCSVQuery;
